export enum FeatureTileIconVariant {
  error = 'error',
  error_outline = 'error_outline',
}

export interface PreLabelStyles {
  fontSize?: string;
  fontWeight?: string;
}
